<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('close')" />
    <div class="modal">
      <div class="title-close">
        <h1 class="modal-title">Share event</h1>
        <span class="material-icons" @click="$emit('close')"> close </span>
      </div>
      <div class="description">
        The event cannot be published without a cover image
      </div>
      <cover-field v-model="cover" :validator="$v.cover" />
      <div class="buttons-cancel-update">
        <main-button outline @click="$emit('close')">Cancel</main-button>
        <main-button @click="onUpdateClick">Update</main-button>
      </div>
    </div>
  </div>
</template>
<script>

import { required } from 'vuelidate/lib/validators'

export default {
  name: 'add-event-cover-modal',
  props: {
    initialCover: String,
  },
  data() {
    return {
      cover: this.initialCover,
    }
  },
  validations() {
    return {
      cover: {required},
    }
  },
  methods: {
    onUpdateClick() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      this.$emit('submit', this.cover)
    },
  },
}
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 45.75rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
.modal-title {
  color: #0277bd;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}
.title-close {
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.material-icons {
  cursor: pointer;
}
.description {
  color: #979797;
  font-family: "Source Sans Pro";
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.buttons-cancel-update {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}

@media screen and (max-width: 288px) {
  .buttons-cancel-update {
    flex-direction: column;
    align-items: center;
  }
}
</style>

